import React from 'react';
import { Icon } from '@material-ui/core';
import apiConfig from '../../../config';

const IllustratorWhiteIcon = `${apiConfig.assets}/ai-white.svg`;
const IllustratorIcon = `${apiConfig.assets}/ai.svg`;
const PhotoshopWhiteIcon = `${apiConfig.assets}/ps-white.svg`;
const PhotoshopIcon = `${apiConfig.assets}/ps.svg`;
const PremierProWhiteIcon = `${apiConfig.assets}/pr-white.svg`;
const PremierProIcon = `${apiConfig.assets}/pr.svg`;
const AfterEffectsWhiteIcon = `${apiConfig.assets}/ae-white.svg`;
const AfterEffectsIcon = `${apiConfig.assets}/ae.svg`;

export default function renderIcons({ small, file_type, title }) {
  let iconComponent = null;
  switch (file_type) {
    case 'folder':
      iconComponent = <Icon>folder_open</Icon>;
      break;
    case 'image':
      iconComponent = <Icon>insert_photo</Icon>;
      break;
    case 'audio':
      iconComponent = <Icon>music_note</Icon>;
      break;
    case 'video':
      iconComponent = <Icon>movie_creation</Icon>;
      break;
    case 'document':
      iconComponent = <Icon>subject</Icon>;
      break;
    default: {
      const extension = title.split('.')[1];
      if (extension === 'ai') {
        iconComponent = (
          <img
            src={small ? IllustratorWhiteIcon : IllustratorIcon}
            alt={title}
          />
        );
      } else if (extension === 'ps') {
        iconComponent = (
          <img src={small ? PhotoshopWhiteIcon : PhotoshopIcon} alt={title} />
        );
      } else if (extension === 'pr') {
        iconComponent = (
          <img src={small ? PremierProWhiteIcon : PremierProIcon} alt={title} />
        );
      } else if (extension === 'ae') {
        iconComponent = (
          <img
            src={small ? AfterEffectsWhiteIcon : AfterEffectsIcon}
            alt={title}
          />
        );
      } else iconComponent = <Icon>subject</Icon>;
    }
  }
  return iconComponent;
}
